import { BlocksLoadingIndicator } from 'blocks-nextjs/blocks-web-components/components/loading-indicator/loading-indicator';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatLoadingIndicator = createComponent({ react: React, tagName: 'cat-loading-indicator', elementClass: BlocksLoadingIndicator });
